<template>
    <transition appear name="fade">
        <div class="login">

            <img class='background' src="/static/background.jpg"/>
            
            <div class="dialog">
                <img src="@/assets/images/logo-white.svg" class="logo">
                <input class='mail' type="text" placeholder="E-Mail-Adresse" v-model="mail">
                <input class='password' type="password" placeholder="Passwort" v-model="password" v-on:keyup.enter="login">

                <input class='submit' type="submit" @click="login" name="Anmelden" value="Anmelden">
                <p>Noch keinen Account? <br><router-link to="register">Jetzt registrieren</router-link></p>

                <p>
                    Passwort vergessen?
                    <router-link to="forgot-password">Passwort zurücksetzen</router-link>
                </p>

            </div>

            <div class="login--footer">
                <router-link to='/datenschutz'>
                  Datenschutz</router-link>

                <router-link to='/impressum'>
                  Impressum</router-link>

                <router-link to='/nutzungsbedingungen'>
                  Nutzungsbedingungen</router-link>
            </div>
                
        </div>
    </transition>
</template>


<style scoped lang="scss">

.logo {
    display: inline-block;
    max-width: 300px;
    margin-bottom: 1em;
}

.background {
    position: fixed;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.1;
    top: 0px;
    left: 0px;
}

.dialog {
    text-align: center;
    position: relative;
    max-width: 300px;

    a:hover {
        background-color: rgba($light-bg-color, 1);
    }
}


.password, .mail, .submit {
    @include general-input();
    display: block;
    max-width: 300px;
    width: 100%;
    background-color: rgba($light-bg-color, 0.3);
    padding: 1em 1.7em;
    text-align: center;
    color: white;
}

.password {
    border-radius: 0px;
    border-bottom: 1px solid rgba($primary-color,0.6);
}

.mail {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-bottom: 1px solid rgba($primary-color,0.6);

}

.login--footer {
    position: absolute;
    bottom: 0.8em;
    width: 100%;
    left: 0px;
    color: white;
    text-align: center;
    a {
        color: white;
        opacity: 0.6;
        font-size: 0.8em;
        font-weight: normal;
        margin: 0 0.3em;

        &:hover {
            opacity: 1;
        }
    }
}

.submit {
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    background-color: rgba($light-bg-color, 0.6);
    // line-height: 0;
    cursor: pointer;
    /*padding: 1em !important;*/

    &:hover {
        background-color: rgba($light-bg-color, 1);
        color: $primary-color;
    }
}
.login {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: $primary-color;
    display: flex;
    overflow: auto;
    padding: 2em;
    padding-top: 4em;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
}


p {
    margin-top: 1em;
    line-height: 1.7;
}

.dialog a {
    background-color: rgba(255,255,255,0.8);
    opacity: 1;
    @include border-radius();
    padding: 0.3em 0.7em;
    display: inline-block;
    color: $primary-color;
    font-size: 1em;
    cursor: pointer;
    text-decoration: none;
}

</style>


<script>
import Parse from 'parse'
import {toast} from '@/utils/interactions'

export default {
    data() {
        return {
            mail: '',
            password: '',
        };
    },
    methods: {
        login() {

            let loader = this.$loading.show();
            var mail = this.mail,
                password = this.password;
            Parse.User.logIn(mail, password).then(() => {
                this.$router.push('/announcements')
            }).catch((err) => {
                if (err && err.code === 101) {
                    toast('E-Mail-Adresse oder Passwort sind falsch', {
                        duration: 6500,
                    });
                }
                console.log(err);
            }).always(() => {
                loader.hide();
            });
        },
    },
    mounted() {
        var user = this.$api.user();
        if (user) {
            this.$router.push('/me')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/login.vue